import mapTemplateGroupToOption from 'ProjectManager/Template/DataManagement/Group/helpers/mapTemplateGroupToOption';

const mapTemplateGroupsToOptions = groups =>
    groups.map(group => mapTemplateGroupToOption(group));

export default mapTemplateGroupsToOptions;
